/** Built-in Geotab group ids. Rule JSONs under `constants/rules` keep their literals. */

/** Root of the security clearance tree. */
export const ROOT_SECURITY_GROUP_ID = "GroupSecurityId";

/** Root of the organisation (company) group tree. */
export const COMPANY_GROUP_ID = "GroupCompanyId";
